import clsx from 'clsx';
import { Logo } from './Logo';
import { useOrganization } from './OrganizationProvider';

/** Chukua's small credit under a tenant's branding. Hidden until the deployment has a company, since Chukua's logo is already the brand then. */
export function PoweredByChukua({ surface = 'auto' }: { surface?: 'auto' | 'dark' }) {
  const { configured } = useOrganization();
  if (!configured) return null;
  return (
    <span className={clsx('inline-flex items-center gap-1.5 text-[11px]', surface === 'dark' ? 'text-panel-fg/55' : 'text-muted')}>
      Powered by
      <Logo height={11} tone={surface === 'dark' ? 'inverse' : 'auto'} />
    </span>
  );
}
